<template>
  <div class="lang-select">

    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
      <div>
        <svg-icon class-name="international-icon" icon-class="language" />
        <span class="lang-text">{{ language === 'zh'?'Chinese': 'English' }}</span>
        <i class="el-icon-caret-bottom icon-arrow-down" />
      </div>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item :disabled="language === 'zh'" command="zh">
          <span class="country-text">Chinese</span>
        </el-dropdown-item>
        <el-dropdown-item :disabled="language === 'en'" command="en">
          <span class="country-text">English</span>

        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>

</template>

<script>
import getPageTitle from '@/utils/get-page-title'
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      document.title = getPageTitle(this.$route.meta.title)
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
  /* ::v-deep .el-dropdown-menu__item.is-disabled .country-text{
    color: #488CE8;
  } */
  .country-text{
    /* color: rgba(54, 66, 80, 0.50); */
    margin-right: 50px;
    font-size: 12px;
    font-weight: 400;
  }
.lang-select{
  position: relative;
  top: -4px;
}
.lang-text{
  margin-left: 8px;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 12px;
  color: #364250;
}
.icon-arrow-down{
  margin-left: 12px;;
  font-size: 12px;
  font-weight: bold;
}
.international-icon{
  font-size: 14px;
}
@media screen and (max-width: 761px) {
 .lang-text{
  display: none;
 }
}
</style>
